import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { seriesAPI } from '../utils/api';
import { Trophy, Calendar } from '@phosphor-icons/react';

const SeriesList = () => {
  const navigate = useNavigate();
  const [seriesList, setSeriesList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSeries = async () => {
      try {
        const { data } = await seriesAPI.listPublic();
        setSeriesList(data);
      } catch (err) {
        console.error('Failed to load series:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchSeries();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="text-[#9E9E9E]">Loading series...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0A0A0A] py-8 px-4" data-testid="series-list-page">
      <div className="max-w-5xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-black text-white" style={{fontFamily: 'Outfit'}}>
            Show Series
          </h1>
          <p className="text-[#9E9E9E] mt-1">Browse multi-show series and cumulative standings</p>
        </div>

        {seriesList.length === 0 ? (
          <div className="bg-[#161616] border border-[#262626] rounded-lg p-12 text-center">
            <Trophy size={48} className="text-[#262626] mx-auto mb-4" />
            <p className="text-[#9E9E9E]">No series available yet</p>
          </div>
        ) : (
          <div className="grid gap-4">
            {seriesList.map(s => (
              <div
                key={s.id}
                onClick={() => navigate(`/series/${s.id}`)}
                data-testid={`public-series-card-${s.id}`}
                className="bg-[#161616] border border-[#262626] hover:border-[#0096FF]/50 rounded-lg p-6 cursor-pointer transition-all group"
              >
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="text-xl font-bold text-white group-hover:text-[#0096FF] transition-colors" style={{fontFamily: 'Outfit'}}>
                      {s.name}
                    </h3>
                    {s.description && <p className="text-[#9E9E9E] text-sm mt-1">{s.description}</p>}
                    {s.org_name && <p className="text-[#0096FF] text-xs mt-1">by {s.org_name}</p>}
                  </div>
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    s.status === 'ACTIVE' ? 'bg-[#34C759]/20 text-[#34C759]' : 'bg-[#9E9E9E]/20 text-[#9E9E9E]'
                  }`}>
                    {s.status}
                  </span>
                </div>
                <div className="flex items-center gap-4 mt-3 text-sm text-[#9E9E9E]">
                  <span className="flex items-center gap-1">
                    <Calendar size={14} /> {s.show_count} show{s.show_count !== 1 ? 's' : ''}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SeriesList;
